import { CommissionFormInline } from "@/components/CommissionForm";

export default function CommissionsPage() {
  return (
    <div data-testid="commissions-page" className="max-w-[1100px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-24">
      <header className="max-w-3xl">
        <div className="eyebrow mb-5">Commissions</div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
          Tell us your idea. <span className="italic">We'll build it.</span>
        </h1>
        <p className="mt-6 text-[#2C2421]/75 leading-relaxed text-lg">
          Share your project on the form below — timber, dimensions, timeline.
          The workshop reviews every brief personally and replies within 48 hours.
        </p>
      </header>

      <div className="mt-14 bg-[#F5F2EB] border border-[#E5E0D8] p-8 md:p-12">
        <CommissionFormInline />
      </div>
    </div>
  );
}
